export default class UrlTerm{
    static readonly tos: string | undefined
}